import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import PermissionContext from "../../context/PermissionContext";
import DrawerContext from "../../context/DrawerContext";
import AutoLogout from "../../utils/useAutoLogout";

import Grid from "@mui/material/Grid";

import SideDrawer from "../../components/layout/SideDrawer";
import PageHeader from "../../components/layout/PageHeader";
import SettingsItemCard from "../../components/user_mngmnt/SettingsItemCard";

const SettingsPage = () => {
  const navigate = useNavigate();

  const { permisionsList, checkUserPermission } = useContext(PermissionContext);
  const { drawerValue, setDrawerValue } = useContext(DrawerContext);

  useEffect(() => {
    if (permisionsList.length > 0) checkUserPermission([
      'Admin-Organisation Create', 'Admin-Manage Organisation', 'Admin-View Organisation List',
      'Admin-View Table Statistics', 'Admin-View Logs List'
    ]);
  }, [permisionsList]);

  const projectItem = {
    name: 'Projects',
    url: '/projects',
    imgPath: '/projects.png',
    permissions: [
      'Admin-Project Create', 'Admin-Manage Project', 'Admin-View Project List'
    ]
  };

  const organisationItem = {
    name: 'Organisations',
    url: '/organisations',
    imgPath: '/organisation.png',
    permissions: [
      'Admin-Organisation Create', 'Admin-Manage Organisation', 'Admin-View Organisation List'
    ]
  };

  const fileTypeItem = {
    name: 'File Types',
    url: '/file-types',
    imgPath: '/filetype.png',
    permissions: [
      'Admin-Organisation Create', 'Admin-Manage Organisation', 'Admin-View Organisation List'
    ]
  };

  const tableStatItem = {
    name: 'DB Statistics',
    url: '/database-statistics',
    imgPath: '/monitoring.png',
    permissions: ['Admin-View Table Statistics']
  };

  const logsItem = {
    name: 'Logs',
    url: '/logs',
    imgPath: '/logs.png',
    permissions: ['Admin-View Logs List']
  };

  const cloudItem = {
    name: 'S3 Navigator',
    url: '/s3-navigator',
    imgPath: '/s3.png',
    permissions: ['Analytics-View files in S3']
  };

  const settingsList = [
    projectItem, organisationItem, fileTypeItem, tableStatItem, logsItem, cloudItem
  ];

  const handleClick = (url) => {
    navigate(url);
  };

  return (
    <AutoLogout>
      <SideDrawer drawerValue={drawerValue} setDrawerValue={setDrawerValue} />
      <div className="mainContainer" style={{ marginLeft: drawerValue.drawerWidth }}>
        <PageHeader title={'Settings'} />

        <Grid container spacing={1} sx={{ marginTop: 2 }}>
          {settingsList.map((data, index) => (
            data.permissions.some(r => permisionsList.includes(r)) &&
            <Grid item xs={12} sm={12} md={3} key={index}>
              <SettingsItemCard data={data} handleClick={handleClick} />
            </Grid>
          ))}
        </Grid>
      </div>
    </AutoLogout>
  );
};

export default SettingsPage;